export default __webpack_public_path__ + "static/media/ic-print.88fb5424.svg";